import React from "react";
import { cn } from "~/utils";

const Card = ({ children, className, description, title }) => (
  <div className={cn("rounded border-l-[5px] bg-[#fafcfe] p-4", className)}>
    {title && <h3 className="m-0 text-base font-bold xl:text-lg">{title}</h3>}
    {description && <p className="m-0 text-sm text-gray-700">{description}</p>}
    <div className="pt-4 xl:px-0.5">{children}</div>
  </div>
);

export default Card;
